import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';
import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const DEFAULT_ICON_SIZE = 16;
const DEFAULT_ICON_COLOR = 'semantic.foreground.secondary';
export const StyledFontAwesomeIcon = styled(FontAwesomeIcon) `
  width: var(--falcon-size, ${({ $size = DEFAULT_ICON_SIZE }) => pxToRem($size)});
  height: var(--falcon-size, ${({ $size = DEFAULT_ICON_SIZE }) => pxToRem($size)});
  color: var(--falcon-color, ${({ $color = DEFAULT_ICON_COLOR }) => get(theme, $color)});
`;
